import { AxiosResponse } from 'axios';
import { Checkbox } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { RadioButton } from 'primereact/radiobutton';
import { FC, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loader from '../../../../components/loader';
import { APIResponseEntity } from '../../../../interface/api-responce';
import { InsuranceAgentErrorType, InsuranceAgentFormEntity, InsuranceAgentReqEntity } from '../../../../interface/insurence-agent.interface';
import { DocumnetVerifyReqEntity, DocumnetVerifyResEntity } from '../../../../interface/ledger-form';
import { TransporterContactDetailEntity, TransporterFileEntity } from '../../../../interface/transporter';
import { APIDocumentVerify, APIToCreateInsuranceAgent, APIToFetchingInsuranceAgentDetailsById, APIToUpdateInsuranceAgentDetails } from '../../../../service/api-service';
import { checkValidInputOnKeyDown, endsWithSpace, removeSpaceOnFirstCharacter, startsWithSpace } from '../../../../service/shared.service';
import { toastOptObj } from '../../../../utils/constants';
import { contactTypeOptions, IdReferenceType } from '../../../../utils/enum';
import { IsNullOrEmptyArray, IsStringNullEmptyOrUndefined } from '../../../../utils/null-check';
import { ALPHABET_SPACE_PATTERN, EMAIL_PATTERN, GST_PATTERN, INDIAN_MOBILE_NO_PATTERN, NAME_PATTERN, NUMBER_ONLY_PATTERN, PAN_NUMBER_PATTERN } from '../../../../utils/pattern';

interface CreateUpdateTransporterPropEntity {
    isUpdated: boolean;
}

const CreateUpdateInsuranceAgentPage: FC<CreateUpdateTransporterPropEntity> = ({ isUpdated }) => {

    const navigate = useNavigate();

    const { id } = useParams();

    const [isLoading, setIsLoading] = useState(false);

    const [isSubmitted, setIsSubmitted] = useState(false);

    const [isVerified, setIsVerified] = useState<boolean>(false);

    const [initialFormValue, setInitialFormValue] = useState<InsuranceAgentFormEntity>({
        name: "",
        idReference: IdReferenceType.GST,
        gstNumber: "",
        panNumber: "",
        billingName: "",
        insuranceCompany: "",
        billingAddress: "",
        addressLine1: "",
        addressLine2: "",
        isActive: true,
    });

    const [initialContactUsers, setInitialContactUsers] = useState<TransporterContactDetailEntity[] | []>([]);

    const [formValues, setFormValues] = useState<InsuranceAgentFormEntity>({
        name: "",
        idReference: IdReferenceType.GST,
        gstNumber: "",
        panNumber: "",
        billingName: "",
        insuranceCompany: "",
        billingAddress: "",
        addressLine1: "",
        addressLine2: "",
        isActive: true,
    });

    const [error, setError] = useState<InsuranceAgentErrorType>({
        name: "Insurance Agent name is required",
        gstNumber: "GST number is required",
        panNumber: "PAN number is required",
        insuranceCompany: "Insurance company name is required",
        contactName: ["Contact name is required"],
        contactNumber: ["Contact number is required"],
        contactEmail: [""]
    });
    const [contactList, setContactList] = useState<TransporterContactDetailEntity[] | []>([{
        contactType: "officePerson",
        contactEmail: "",
        contactName: "",
        contactNumber: "",
        isPrimary: true,
        isActive: true
    }]);

    const Status = [
        { name: "Active", code: true },
        { name: "Inactive", code: false },
    ];

    const [isGSTVerified, setIsGSTVerified] = useState(false);

    const [showAttachmentModal, setShowAttachmentModal] = useState(false);

    const [attachments, setAttachments] = useState<TransporterFileEntity[]>([]);

    const isVerifyEnabled =
        formValues.idReference === IdReferenceType.GST
            ? GST_PATTERN.test(formValues.gstNumber)
            : PAN_NUMBER_PATTERN.test(formValues.panNumber);

    // const [attachmentDescription, setAttachmentDescription] = useState<string>("");

    const handleChange = (fieldName: string, value: any) => {

        let errorMsg = "";

        switch (fieldName) {

            case "name":
                if (IsStringNullEmptyOrUndefined(value)) {
                    errorMsg = "Insurance Agent name is required";
                } else if (startsWithSpace(value)) {
                    errorMsg = "Whitespace is not allowed at the beginning";
                } else if (endsWithSpace(value)) {
                    errorMsg = "Whitespace is not allowed at the end";
                } else if (value.length < 3) {
                    errorMsg = "Name must be at least 3 characters";
                } else if (value.length > 50) {
                    errorMsg = "Maximum 50 characters allowed";
                }

                setError(prev => ({ ...prev, name: errorMsg }));
                break;

            case "insuranceCompany":
                if (IsStringNullEmptyOrUndefined(value)) {
                    errorMsg = "Insurance company name is required";
                } else if (startsWithSpace(value)) {
                    errorMsg = "Whitespace is not allowed at the beginning";
                } else if (endsWithSpace(value)) {
                    errorMsg = "Whitespace is not allowed at the end";
                } else if (value.trim().length < 3) {
                    errorMsg = "Minimum 3 characters required";
                } else if (value.length > 50) {
                    errorMsg = "Maximum 50 characters allowed";
                }

                setError(prev => ({ ...prev, insuranceCompany: errorMsg }));
                break;

            case "gstNumber":
                value = value.toUpperCase();
                if (value !== formValues.gstNumber) {
                    setIsGSTVerified(false);
                }
                if (IsStringNullEmptyOrUndefined(value)) {
                    errorMsg = "GST number is required";
                } else if (startsWithSpace(value)) {
                    errorMsg = "Whitespace is not allowed at the beginning";
                } else if (endsWithSpace(value)) {
                    errorMsg = "Whitespace is not allowed at the end";
                } else if (!GST_PATTERN.test(value)) {
                    errorMsg = "Invalid GST number";
                } else if (!isGSTVerified) {
                    errorMsg = "Please verify GST number";
                }

                setError(prev => ({ ...prev, gstNumber: errorMsg }));
                setFormValues(prev => ({
                    ...prev,
                    gstNumber: value,
                    billingName: "",
                    billingAddress: "",
                    addressLine1: "",
                    addressLine2: "",
                    panNumber: ""
                }));
                return;

            case "panNumber":
                value = value.toUpperCase();

                if (value !== formValues.panNumber) {
                    setIsVerified(false);
                }

                if (IsStringNullEmptyOrUndefined(value)) {
                    errorMsg = "PAN number is required";
                } else if (startsWithSpace(value)) {
                    errorMsg = "Whitespace is not allowed at the beginning";
                } else if (endsWithSpace(value)) {
                    errorMsg = "Whitespace is not allowed at the end";
                } else if (!PAN_NUMBER_PATTERN.test(value)) {
                    errorMsg = "Invalid PAN number";
                } else if (!isVerified) {
                    errorMsg = "Please verify PAN number";
                }

                setError(prev => ({ ...prev, panNumber: errorMsg }));

                setFormValues(prev => ({
                    ...prev,
                    panNumber: value,
                    billingName: "",
                    billingAddress: "",
                    addressLine1: "",
                    addressLine2: ""
                }));
                return;

            case "idReference":
                setFormValues(prev => ({
                    ...prev,
                    idReference: value,
                    gstNumber: "",
                    panNumber: "",
                    billingName: "",
                    billingAddress: "",
                    addressLine1: "",
                    addressLine2: ""
                }));

                setError(prev => ({
                    ...prev,
                    gstNumber: "GST number is required",
                    panNumber: "PAN number is required"
                }));

                setIsVerified(false);
                setIsGSTVerified(false);
                return;

            default:
                break;
        }
        setFormValues(prev => ({
            ...prev,
            [fieldName]: value
        }));
    };

    const onDocumentVerify = async (): Promise<void> => {
        const referenceNumber =
            formValues.idReference === IdReferenceType.GST
                ? formValues.gstNumber
                : formValues.panNumber;

        if (!IsStringNullEmptyOrUndefined(referenceNumber)) {
            try {
                const reqObj: DocumnetVerifyReqEntity = {
                    idReference: formValues.idReference,
                    referenceNumber: referenceNumber,
                };
                setIsLoading(true);
                const resp: AxiosResponse<APIResponseEntity> = await APIDocumentVerify(reqObj);
                setIsLoading(false);
                if (resp && resp.data && resp.status === 200) {
                    if (resp.data.status) {
                        setIsVerified(true);
                        toast.success(resp.data.message, { ...toastOptObj });
                        const documentDetails: DocumnetVerifyResEntity = resp.data.data.respData;
                        const address = documentDetails.billingAddress || "";

                        const parts = address.split(",").map(p => p.trim());

                        const mid = Math.ceil(parts.length / 2);

                        const addressLine1 = parts.slice(0, mid).join(", ");
                        const addressLine2 = parts.slice(mid).join(", ");

                        console.log("documentDetails::", documentDetails);
                        console.log("API PAN:", documentDetails.panNumber);
                        setFormValues((prev) => ({
                            ...prev,
                            billingName: documentDetails.billingName || "",
                            billingAddress: documentDetails.billingAddress,
                            addressLine1,
                            addressLine2,
                            panNumber: documentDetails.panNumber || formValues.panNumber
                        }));

                        if (formValues.idReference === IdReferenceType.GST) {
                            setIsGSTVerified(true);
                            setError(prev => ({ ...prev, gstNumber: "" }));
                        } else {
                            setIsVerified(true);
                            setError(prev => ({ ...prev, panNumber: "" }));
                        }
                    } else {
                        setIsGSTVerified(false);
                        toast.error(resp.data.message, { ...toastOptObj });
                    }
                } else {
                    toast.error(resp.data.message, { ...toastOptObj });
                }
            } catch (error) {
                setIsLoading(false);
            }
        }
    };

    const handleAddRow = () => {
        setContactList((prev) => {
            const newList = [
                ...prev,
                {
                    contactType: "officePerson",
                    contactEmail: "",
                    contactName: "",
                    contactNumber: "",
                    isPrimary: false,
                    isActive: true
                }
            ];

            if (isSubmitted) {
                setError(prev => ({
                    ...prev,
                    contactName: [...prev.contactName, "Contact name is required"],
                    contactNumber: [...prev.contactNumber, "Contact number is required"],
                    contactEmail: [...prev.contactEmail, ""]
                }));
            }

            return newList;
        });
    };


    const handleUpdateContact = (
        index: number,
        field: keyof TransporterContactDetailEntity,
        value: any
    ) => {

        let errorMsg = "";

        switch (field) {

            case "contactName":
                if (!value) errorMsg = "Contact name is required";
                else if (startsWithSpace(value)) errorMsg = "Whitespace is not allowed at the beginning";
                else if (endsWithSpace(value)) errorMsg = "Whitespace is not allowed at the end";
                else if (!NAME_PATTERN.test(value)) errorMsg = "Special characters are not allowed";
                break;

            case "contactNumber":
                if (!value) errorMsg = "Contact number is required";
                else if (!INDIAN_MOBILE_NO_PATTERN.test(value)) errorMsg = "Invalid contact number";
                break;

            case "contactEmail":
                if (IsStringNullEmptyOrUndefined(value)) {
                    errorMsg = "";
                }
                else if (!EMAIL_PATTERN.test(value)) {
                    errorMsg = "Please enter a valid contact email!";
                }
                else if (
                    contactList.some((el, i) =>
                        !IsStringNullEmptyOrUndefined(el.contactEmail) &&
                        el.contactEmail === value &&
                        i !== index
                    )
                ) {
                    errorMsg = "Contact email is already in use!";
                }
                break;
        }

        setContactList(prev => {
            const updated = [...prev];
            updated[index] = { ...updated[index], [field]: value };
            return updated;
        });

        setError(prev => {
            if (field === "contactName" || field === "contactNumber" || field === "contactEmail") {
                const updated = [...(prev[field] as string[] || [])];
                updated[index] = errorMsg;
                return { ...prev, [field]: updated };
            }
            return prev;
        });
    };


    const handleSaveDetail = async () => {
        setIsSubmitted(true);
        handleChange("name", formValues.name);
        handleChange("insuranceCompany", formValues.insuranceCompany);

        if (formValues.idReference === IdReferenceType.GST) {
            handleChange("gstNumber", formValues.gstNumber);
        } else {
            handleChange("panNumber", formValues.panNumber);
        }

        contactList.forEach((item, index) => {
            handleUpdateContact(index, "contactName", item.contactName);
            handleUpdateContact(index, "contactNumber", item.contactNumber);
            handleUpdateContact(index, "contactEmail", item.contactEmail);
        });
        let isValid = true;
        const hasContactErrors = contactList.some((item, index) => {
            return (
                !item.contactName?.trim() ||
                !item.contactNumber?.trim() ||
                error.contactName[index] ||
                error.contactNumber[index] ||
                error.contactEmail[index]
            );
        });
        if (
            error.name ||
            error.insuranceCompany ||
            (formValues.idReference === IdReferenceType.GST && error.gstNumber) ||
            (formValues.idReference === IdReferenceType.PAN && error.panNumber) ||
            hasContactErrors
        ) {
            isValid = false;
        }
        if (!isValid) {
            const errorElement = document.querySelector('[data-error="transporter-error"]');
            if (errorElement) {
                errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
            }
            return;
        }

        setIsLoading(true);

        try {
            const data: InsuranceAgentReqEntity = {
                ...formValues,
                contactUsers: contactList
            };

            const resp: AxiosResponse<APIResponseEntity> =
                (id && !IsStringNullEmptyOrUndefined(id) && isUpdated)
                    ? await APIToUpdateInsuranceAgentDetails(data, id)
                    : await APIToCreateInsuranceAgent(data);

            if (!resp || resp.status !== 200 || !resp.data) {
                return;
            }

            const apiRespPayload = resp.data;

            if (apiRespPayload.statusCode !== 200 || !apiRespPayload.data) {
                toast.error(apiRespPayload.message || apiRespPayload.errorMsg, { ...toastOptObj });
                return;
            }

            navigate("/settings/insurance-agents");

        } catch (error) {
            return;
        } finally {
            setIsLoading(false);
        }
    };

    const handleDeleteRow = (contactIndex: number) => {
        setContactList((prev) => {
            const toDelete = prev[contactIndex];
            const updated = prev.filter((_, index) => index !== contactIndex);

            if (!toDelete.isPrimary) return updated;

            if (updated.length > 0) {
                updated[0] = { ...updated[0], isPrimary: true };
            }

            return updated;
        });
    };

    const handleFetchingTransporterDetailById = async () => {
        if (id && !IsStringNullEmptyOrUndefined(id)) {
            setIsLoading(true);
            const resp: AxiosResponse<APIResponseEntity> = await APIToFetchingInsuranceAgentDetailsById(id);

            if (!resp || (resp && (resp.status !== 200 || !resp.data))) { setIsLoading(false); return false; }

            const apiRespPayload: APIResponseEntity = resp.data;

            if (apiRespPayload.statusCode !== 200 || !apiRespPayload.data) {
                setIsLoading(false);
                toast.error(apiRespPayload.message || apiRespPayload.errorMsg,
                    { ...toastOptObj });
                return;
            }
            // const { contactUsers, ...transporterDetail }: TransporterReqEntity = apiRespPayload.data.data;
            const { contactUsers, agentFiles, description, ...transporterDetail } = apiRespPayload.data.data;
            setFormValues((prev) => ({ ...transporterDetail }));
            setInitialFormValue((prev) => ({ ...transporterDetail }));

            if (!IsStringNullEmptyOrUndefined(transporterDetail.gstNumber)) {
                setIsGSTVerified(true);
            }

            if (!IsStringNullEmptyOrUndefined(transporterDetail.panNumber)) {
                setIsVerified(true);
            }

            setContactList(prev => contactUsers);
            setError(prev => ({
                ...prev,
                name: !IsStringNullEmptyOrUndefined(transporterDetail.name) ? "" : "Insurance Agent name is required",

                insuranceCompany: !IsStringNullEmptyOrUndefined(transporterDetail.insuranceCompany)
                    ? ""
                    : "Insurance company name is required",
                gstNumber:
                    transporterDetail.idReference === IdReferenceType.GST
                        ? (!IsStringNullEmptyOrUndefined(transporterDetail.gstNumber) ? "" : "GST number is required")
                        : "",
                panNumber:
                    transporterDetail.idReference === IdReferenceType.PAN
                        ? (!IsStringNullEmptyOrUndefined(transporterDetail.panNumber) ? "" : "PAN number is required")
                        : "",
                contactName: contactUsers.map((item: TransporterContactDetailEntity) =>
                    !IsStringNullEmptyOrUndefined(item.contactName) ? "" : "Contact name is required"
                ),
                contactNumber: contactUsers.map((item: TransporterContactDetailEntity) =>
                    !IsStringNullEmptyOrUndefined(item.contactNumber) ? "" : "Contact number is required"
                ),
                contactEmail: contactUsers.map((item: TransporterContactDetailEntity) =>
                    !IsStringNullEmptyOrUndefined(item.contactEmail) && !EMAIL_PATTERN.test(item.contactEmail)
                        ? "Please enter a valid contact email!"
                        : ""
                )
            }));
            setInitialContactUsers(prev => contactUsers);
            setAttachments(agentFiles || []);
            // setAttachmentDescription(description || "");
            setIsLoading(false);
        }
    }

    // const handleDisabled = (): boolean => {
    //     return (
    //         isUpdated && !IsStringNullEmptyOrUndefined(id as string) &&
    //         JSON.stringify(formValues) === JSON.stringify(initialFormValue) &&
    //         JSON.stringify(contactList) === JSON.stringify(initialContactUsers)
    //     )
    // }

    useEffect(() => {
        if (id) return;

        setIsVerified(false);
        setIsGSTVerified(false);


        setFormValues((prev) => ({
            ...prev,
            gstNumber: "",
            panNumber: "",
            billingName: "",
            billingAddress: "",
            addressLine1: "",
            addressLine2: ""
        }));

    }, [formValues.idReference]);

    useEffect(() => {
        if (id && !IsStringNullEmptyOrUndefined(id)) {
            handleFetchingTransporterDetailById()
        }
    }, [id])

    const downloadFile = (url: string) => {
        window.open(url, "_blank");
    };

    const formatDate = (date?: string) => {
        if (!date) return "-";

        return new Date(date).toLocaleString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit"
        });
    };
    return (
        <>
            <Loader isLoading={isLoading} />
            <div className="content-wrapper">
                <div className="col-12 mb-3">
                    <div className="card card-rounded">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-12">
                                    <h4 className="card-title">{isUpdated ? "Update" : "Add"} Insurance Agent </h4>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label> INSURANCE AGENT NAME <sup className='mandatory'>*</sup></label>
                                                <input
                                                    autoComplete='one-time-code'
                                                    type="text" className="form-control form-control-lg" name='name'
                                                    maxLength={100}
                                                    value={formValues.name}
                                                    onChange={(e) => {
                                                        handleChange(e.target.name, e.target.value);
                                                    }}
                                                    onKeyDown={(event: any) => {
                                                        checkValidInputOnKeyDown(event, ALPHABET_SPACE_PATTERN);
                                                    }}
                                                />
                                                {isSubmitted && error.name && (<small className="text-danger" data-error="transporter-error">{error.name}</small>)}
                                            </div>
                                            <div className="form-group">
                                                <label>INSURANCE COMPANY NAME<sup className='mandatory'>*</sup></label>
                                                <input
                                                    autoComplete='one-time-code'
                                                    type="text" className="form-control form-control-lg"
                                                    maxLength={100}
                                                    name="insuranceCompany"
                                                    value={formValues.insuranceCompany}
                                                    onChange={(e) => {
                                                        handleChange(e.target.name, e.target.value);
                                                    }}
                                                    onKeyDown={(event: any) => {
                                                        removeSpaceOnFirstCharacter(event);
                                                    }}
                                                />
                                                {isSubmitted && error.insuranceCompany && (
                                                    <small className="text-danger" data-error="transporter-error">
                                                        {error.insuranceCompany}
                                                    </small>
                                                )}
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>ID TYPE</label>
                                                <div className="d-flex gap-4 mt-2">
                                                    {[IdReferenceType.GST, IdReferenceType.PAN].map((type) => (
                                                        <div key={type} className="d-flex align-items-center">
                                                            <RadioButton
                                                                inputId={type}
                                                                name="idReference"
                                                                value={type}
                                                                onChange={(e) => handleChange(e.target.name, e.value)}
                                                                checked={formValues.idReference === type}
                                                                className="me-2"
                                                            />
                                                            <label>{type}</label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>
                                                    {formValues.idReference === IdReferenceType.PAN ? "PAN CARD" : "GST"} NUMBER <sup className='mandatory'>*</sup>
                                                </label>

                                                <div className="d-flex gap-2">
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-lg"
                                                        name={formValues.idReference === IdReferenceType.GST ? 'gstNumber' : 'panNumber'}
                                                        value={formValues[formValues.idReference === IdReferenceType.GST ? "gstNumber" : "panNumber"]}
                                                        onChange={(e) => {
                                                            const value = e.target.value.toUpperCase();
                                                            handleChange(e.target.name, value);
                                                        }}
                                                        onKeyDown={(event: any) => {
                                                            removeSpaceOnFirstCharacter(event);
                                                        }}
                                                    />

                                                    <button
                                                        type='button'
                                                        className="btn btn-success"
                                                        // disabled={!isVerifyEnabled || isVerified}
                                                        disabled={
                                                            !isVerifyEnabled ||
                                                            (formValues.idReference === IdReferenceType.GST ? isGSTVerified : isVerified)
                                                        }
                                                        onClick={onDocumentVerify}
                                                    >
                                                        Verify
                                                    </button>
                                                </div>

                                                <small className="text-muted">
                                                    {formValues.idReference === IdReferenceType.PAN
                                                        ? 'Example: ABCTY1234D'
                                                        : 'Example: 22ABCDE1234F1Z5'}
                                                </small>
                                                <div>
                                                    {formValues.idReference === IdReferenceType.GST
                                                        ? isSubmitted && error.gstNumber && (
                                                            <small className="text-danger" data-error="transporter-error">
                                                                {error.gstNumber}
                                                            </small>
                                                        )
                                                        : isSubmitted && error.panNumber && (
                                                            <small className="text-danger" data-error="transporter-error">
                                                                {error.panNumber}
                                                            </small>
                                                        )
                                                    }
                                                </div>


                                            </div>
                                        </div>
                                        {/* </div> */}
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label> BILLING NAME </label>
                                                <input
                                                    autoComplete='one-time-code'
                                                    type="text" className="form-control form-control-lg" name='billingName'
                                                    disabled={true}
                                                    value={formValues.billingName}
                                                />

                                            </div>
                                        </div>
                                        {/* <div className="col-md-3">
                                            <div className="form-group">
                                                <label> BILLING ADDRESS </label>
                                                <input
                                                    autoComplete='one-time-code'
                                                    type="text" className="form-control form-control-lg" name='billingAddress'
                                                    disabled={true}
                                                    value={formValues.billingAddress}
                                                />
                                            </div>
                                        </div> */}

                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label> ADDRESS LINE 1 </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-lg"
                                                    name="addressLine1"
                                                    disabled
                                                    value={formValues.addressLine1}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>ADDRESS LINE 2 </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-lg"
                                                    name="addressLine2"
                                                    disabled
                                                    value={formValues.addressLine2}
                                                />

                                            </div>
                                        </div>

                                        {/* <input
                                            type="text"
                                            className="form-control form-control-lg"
                                            name="addressLine1"
                                            disabled
                                            value={formValues.addressLine1}
                                        />

                                        <input
                                            type="text"
                                            className="form-control form-control-lg"
                                            name="addressLine2"
                                            disabled
                                            value={formValues.addressLine2}
                                        /> */}

                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label> PAN NUMBER</label>
                                                <input
                                                    autoComplete='one-time-code'
                                                    type="text" className="form-control form-control-lg" name='panNumber'
                                                    maxLength={50}
                                                    disabled={true}
                                                    value={formValues.panNumber}
                                                    onKeyDown={(event: any) => {
                                                        removeSpaceOnFirstCharacter(event);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 mb-3">
                                            <div className="form-group">
                                                <label>
                                                    STATUS<sup className="mandatory">*</sup>
                                                </label>
                                                <div className="d-flex gap-4 mt-2">
                                                    {Status.map((option: any) => (
                                                        <div
                                                            key={option.code}
                                                            className="d-flex align-items-center"
                                                        >
                                                            <RadioButton
                                                                inputId={String(option.code)}
                                                                name="isActive"
                                                                className="me-2"
                                                                onChange={(e) =>
                                                                    handleChange(e.target.name, e.value)
                                                                }
                                                                value={option.code}
                                                                checked={formValues.isActive === option.code}
                                                            />
                                                            <label className="me-2">{option.name}</label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12 mb-3">
                    <div className="card card-rounded">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-12">
                                    <h4 className="card-title">{isUpdated ? "Update" : "Add"} Contact Details </h4>
                                    <div className="col-lg-12 col-md-12 mb-md-0 mb-3">
                                        <div className="form-group">
                                            <div className="table-responsive">
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            {/* <th>Contact Type<sup className='mandatory'>*</sup></th> */}
                                                            <th>Contact Name<sup className='mandatory'>*</sup></th>
                                                            <th>Contact Email</th>
                                                            <th>Contact No<sup className='mandatory'>*</sup></th>
                                                            <th>Primary Contact<sup className='mandatory'>*</sup></th>
                                                            <th>Action<sup className='mandatory'>*</sup></th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {contactList.map((item, index) => (
                                                            <tr key={index} >
                                                                {/* <td style={{ verticalAlign: 'top', border: "none" }}>
                                                                    <div className='form-group d-flex flex-column gap-2'>

                                                                        <Dropdown
                                                                            value={item.contactType}
                                                                            options={contactTypeOptions}
                                                                            optionLabel="label"
                                                                            optionValue="value"
                                                                            placeholder="Select Contact Type"
                                                                            style={{ width: "160px" }}
                                                                            onChange={(e) => {
                                                                                handleUpdateContact(index, "contactType", e.value)
                                                                            }}
                                                                        />

                                                                        {isSubmitted && IsStringNullEmptyOrUndefined(item.contactType) && (
                                                                            <small className="text-danger" data-error="transporter-error">
                                                                                Please select contact type!
                                                                            </small>
                                                                        )}

                                                                    </div>
                                                                </td> */}
                                                                <td style={{ verticalAlign: 'top', border: "none" }}>
                                                                    <div className='form-group d-flex flex-column gap-2'>
                                                                        <input type="text"
                                                                            name='contactName'
                                                                            className="form-control form-control-lg"
                                                                            maxLength={100}
                                                                            placeholder='Enter Contact Name'
                                                                            onKeyDown={(event: any) => {
                                                                                checkValidInputOnKeyDown(event, NAME_PATTERN);
                                                                                removeSpaceOnFirstCharacter(event);
                                                                            }}
                                                                            value={item.contactName}
                                                                            onChange={(e) => {
                                                                                handleUpdateContact(index, (e.target.name as keyof TransporterContactDetailEntity), e.target.value)
                                                                            }}
                                                                        />
                                                                        <div>
                                                                            {isSubmitted && error.contactName[index] && (
                                                                                <small className="text-danger">
                                                                                    {error.contactName[index]}
                                                                                </small>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td style={{ verticalAlign: 'top', border: "none" }}>
                                                                    <div className='form-group d-flex flex-column gap-2'>
                                                                        <input type="text"
                                                                            name='contactEmail'
                                                                            autoComplete="off"
                                                                            className="form-control form-control-lg"
                                                                            placeholder='Enter Contact Email'
                                                                            onKeyDown={(event: any) => {
                                                                                removeSpaceOnFirstCharacter(event);
                                                                            }}
                                                                            onPaste={(event) => {
                                                                                const pasteData = event.clipboardData.getData("Text");
                                                                                if (!EMAIL_PATTERN.test(pasteData)) {
                                                                                    event.preventDefault();
                                                                                }
                                                                            }}
                                                                            value={item.contactEmail}
                                                                            onChange={(e) => {
                                                                                handleUpdateContact(index, (e.target.name as keyof TransporterContactDetailEntity), e.target.value)
                                                                            }}
                                                                        />
                                                                        <div>
                                                                            {isSubmitted && error.contactEmail[index] && (
                                                                                <small className="text-danger" data-error="transporter-error">
                                                                                    {error.contactEmail[index]}
                                                                                </small>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td style={{ verticalAlign: 'top', border: "none" }}>
                                                                    <div className='form-group d-flex flex-column gap-2'>
                                                                        <input type="text"
                                                                            name='contactNumber'
                                                                            className="form-control form-control-lg"
                                                                            placeholder='Enter Conatct Number'
                                                                            onKeyDown={(event: any) => {
                                                                                checkValidInputOnKeyDown(event, NUMBER_ONLY_PATTERN);
                                                                                removeSpaceOnFirstCharacter(event);
                                                                            }}
                                                                            autoComplete="off"
                                                                            onPaste={(event) => {
                                                                                const pasteData = event.clipboardData.getData("Text");
                                                                                if (!NUMBER_ONLY_PATTERN.test(pasteData)) {
                                                                                    event.preventDefault();
                                                                                }
                                                                            }}
                                                                            maxLength={10}
                                                                            value={item.contactNumber}
                                                                            onChange={(e) => {
                                                                                handleUpdateContact(index, (e.target.name as keyof TransporterContactDetailEntity), e.target.value);
                                                                            }}
                                                                        />
                                                                        <div>
                                                                            {isSubmitted && error.contactNumber[index] && (
                                                                                <small className="text-danger">
                                                                                    {error.contactNumber[index]}
                                                                                </small>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td style={{
                                                                    verticalAlign: 'middle', border: "none", paddingTop: (isSubmitted && (
                                                                        error.contactName[index] ||
                                                                        error.contactNumber[index] ||
                                                                        error.contactEmail[index]
                                                                    ))
                                                                        ? "0px"
                                                                        : "7px"
                                                                }}>
                                                                    <div className='form-group d-flex   align-items-center gap-2'>
                                                                        <Checkbox
                                                                            name="isPrimary"
                                                                            checked={item.isPrimary}
                                                                            onChange={(e) => {
                                                                                if (!item.isPrimary) {
                                                                                    handleUpdateContact(index, "isPrimary", true);
                                                                                    if (!item.isActive) {
                                                                                        handleUpdateContact(index, "isActive", true);
                                                                                    }
                                                                                }
                                                                            }}
                                                                        />
                                                                        <label> Is Primary </label>
                                                                    </div>
                                                                </td>
                                                                <td style={{
                                                                    verticalAlign: 'middle', border: "none", paddingTop: (isSubmitted && (
                                                                        error.contactName[index] ||
                                                                        error.contactNumber[index] ||
                                                                        error.contactEmail[index]
                                                                    ))
                                                                        ? "0px"
                                                                        : "7px"
                                                                }}>
                                                                    <div className='form-group d-flex align-items-center gap-2'>
                                                                        <Checkbox
                                                                            name="isActive"
                                                                            checked={item.isPrimary ? item.isActive : item.isActive}
                                                                            disabled={item.isPrimary}
                                                                            onChange={(e) => {
                                                                                handleUpdateContact(index, "isActive", e.checked as boolean)
                                                                            }}
                                                                        />
                                                                        <label> Is Active </label>
                                                                    </div>
                                                                </td>
                                                                <td style={{
                                                                    verticalAlign: 'top', border: "none", paddingTop:
                                                                        (isSubmitted && (
                                                                            error.contactName[index] ||
                                                                            error.contactNumber[index] ||
                                                                            error.contactEmail[index]
                                                                        )) ? "12px"
                                                                            : "9px"
                                                                }} >
                                                                    <div style={{ paddingTop: "10px" }} role='button' className='d-flex align-items-center gap-2 mt-2' >
                                                                        <div>
                                                                            {
                                                                                ((index === 0 && contactList.length === 0) || index === contactList.length - 1) && (
                                                                                    contactList.length < 10 &&
                                                                                    <div >
                                                                                        <img src="assets/images/plus-circle.svg" style={{ width: "22px", height: "22px" }} alt="plus-circle" onClick={handleAddRow} />
                                                                                    </div>
                                                                                )
                                                                            }
                                                                        </div>
                                                                    </div>

                                                                </td>
                                                            </tr>

                                                        ))}
                                                    </tbody>
                                                </table>

                                            </div>
                                        </div>
                                        <div>
                                            <div className='d-flex align-items-center gap-3'>
                                                <button
                                                    type="button"
                                                    className="btn btn-cancel text-dark m-0"
                                                    onClick={() => {
                                                        navigate("/settings/insurance-agents")
                                                    }}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-success me-2"
                                                    disabled={false}
                                                    onClick={handleSaveDetail}
                                                >
                                                    Save
                                                </button>
                                                {!IsNullOrEmptyArray(attachments) && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary"
                                                        onClick={() => setShowAttachmentModal(true)}
                                                    >
                                                        View Attachments
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Dialog
                header="Download Attachments"
                draggable={false} resizable={false}
                visible={showAttachmentModal}
                style={{ width: '700px' }}
                modal
                onHide={() => setShowAttachmentModal(false)}
            >
                <div className="invoice-attachment-table-container">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>UPLOADED AT</th>
                                <th>DESCRIPTION</th>
                                <th>DOWNLOAD</th>
                            </tr>
                        </thead>

                        <tbody>
                            {attachments.map((item, index) => (
                                <tr key={index}>
                                    <td>{formatDate(item.createdAt)}</td>
                                    <td style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                                        {item.description || "-"}
                                    </td>
                                    <td>
                                        <i
                                            className="pi pi-download"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => downloadFile(item.filePath)}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="d-flex justify-content-end mt-3">
                    <button
                        className="btn btn-secondary"
                        onClick={() => setShowAttachmentModal(false)}
                    >
                        Close
                    </button>
                </div>
            </Dialog>
        </>
    )
}

export default CreateUpdateInsuranceAgentPage